module.exports = __webpack_public_path__ + "static/media/location.bdfeb66a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/DogProfile/location.svg
// module id = 341
// module chunks = 0